module.exports = __webpack_public_path__ + "static/media/erezLogo.c4987863.png";